import React from "react";
import { Alert, Box, Chip, Stack, Typography } from "@mui/material";

export interface IntentConstraintView {
  dimension: string;
  operator: string;
  importance: "must" | "prefer" | "avoid" | "flexible";
  value_json: unknown;
  provenance: string;
  confidence?: number;
  verified_at?: string | null;
}

export interface IntentProfileView {
  version: number;
  summary?: string | null;
  client_intent_constraints?: IntentConstraintView[];
  constraints?: IntentConstraintView[];
}

const displayValue = (value: unknown) =>
  Array.isArray(value) ? value.join(", ") : typeof value === "object" ? JSON.stringify(value) : String(value ?? "Unknown");

export default function IntentProfilePanel({ profile }: { profile: IntentProfileView | null }) {
  if (!profile) return <Alert severity="info">No versioned intent profile yet. Current client preferences remain unchanged.</Alert>;
  const constraints = profile.client_intent_constraints ?? profile.constraints ?? [];
  return <Box>
    <Typography variant="subtitle1" fontWeight={700}>Intent profile v{profile.version}</Typography>
    {profile.summary && <Typography color="text.secondary" sx={{ mb: 1 }}>{profile.summary}</Typography>}
    <Stack spacing={1}>
      {constraints.map((item, index) => <Box key={`${item.dimension}-${index}`} sx={{ p: 1.5, border: "1px solid", borderColor: "divider", borderRadius: 1 }}>
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <Typography fontWeight={600}>{item.dimension}</Typography>
          <Chip size="small" label={item.importance} color={item.importance === "must" ? "primary" : "default"} />
          <Chip size="small" variant="outlined" label={item.provenance.replaceAll("_", " ")} />
        </Stack>
        <Typography variant="body2">{item.operator}: {displayValue(item.value_json)}</Typography>
      </Box>)}
    </Stack>
  </Box>;
}
